import {svgIconWrapper} from '../svg-icon-wrapper';

import PlaneRegularDiagonal from './plane-regular-diagonal-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PlaneRegularDiagonal {...validProps} />;
}

SvgComponent.iconName = 'plane-regular-diagonal';

export const PlaneRegularDiagonalIcon = svgIconWrapper(SvgComponent);
